import { z } from "zod";

export const fossilEnergyTypeSchema = z.enum([
  "fuel",
  "diesel",
  "GPL",
  "GNV",
]);

export const electricEnergyTypeSchema = z.enum([
  "electric",
  "hybrideFuel",
  "hybrideDiesel",
]);

export const energyTypeSchema = z.enum([
  ...fossilEnergyTypeSchema.options,
  ...electricEnergyTypeSchema.options,
]);

export const fossilEnergyTypes = fossilEnergyTypeSchema.options;
export const electricEnergyTypes = electricEnergyTypeSchema.options;
export const energyTypes = energyTypeSchema.options;

export type FossilEnergyType = z.infer<typeof fossilEnergyTypeSchema>;
export type ElectricEnergyType = z.infer<typeof electricEnergyTypeSchema>;
export type EnergyType = z.infer<typeof energyTypeSchema>;

export const acronymEnergyTypeSchema = z.enum([
  "GO",
  "EL",
  "AC",
  "EE",
  "EG",
  "EH",
  "EM",
  "EN",
  "EP",
  "EQ",
  "ER",
  "ES",
  "ET",
  "FE",
  "FG",
  "HE",
  "FH",
  "FP",
  "FQ",
  "FL",
  "FN",
  "GA",
  "GE",
  "GF",
  "GG",
  "GH",
  "GL",
  "GM",
  "GN",
  "GP",
  "GQ",
  "GZ",
  "H2",
  "HH",
  "NE",
  "NH",
  "PE",
  "PH",
  "PL",
]);

export const acronymEnergyTypes = acronymEnergyTypeSchema.options;
export type AcronymEnergyType = z.infer<typeof acronymEnergyTypeSchema>;

export const energyGroups: {
  acronymEnergies: AcronymEnergyType[];
  energy: EnergyType;
}[] = [
  {
    acronymEnergies: ["ES", "ET", "FE", "FH", "FP", "FQ"],
    energy: "fuel",
  },
  {
    acronymEnergies: ["GO", "GA", "GE", "GF", "GG", "PL"],
    energy: "diesel",
  },
  {
    acronymEnergies: ["EG", "EQ", "FG", "GP", "PH", "ER", "FL", "PE"],
    energy: "GPL",
  },
  {
    acronymEnergies: ["EE", "EH"],
    energy: "hybrideFuel",
  },
  {
    acronymEnergies: ["GH", "GQ", "GL", "GM"],
    energy: "hybrideDiesel",
  },
  {
    acronymEnergies: ["EN", "EP", "FN", "GN", "GZ", "NH", "EM", "NE"],
    energy: "GNV",
  },
  { acronymEnergies: ["AC", "EL", "H2", "HE", "HH"], energy: "electric" },
];

export const electricAcronymEnergies = energyGroups
  .filter(({ energy }) => electricEnergyTypeSchema.safeParse(energy).success)
  .flatMap(({ acronymEnergies }) => acronymEnergies);
